<template>
    <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
        <fieldset class="kgr-grid__cell">
            <legend
                v-t="'Adresse'"
                class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
            ></legend>

            <kgr-form-row
                :label="$t('member.company')"
                :error="error"
                field-name="company"
            >
                <input
                    v-model.trim="member.company"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.careOf')"
                :error="error"
                field-name="careOf"
            >
                <input
                    v-model.trim="member.careOf"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>
            <kgr-form-row
                :label="$t('member.street')"
                :error="error"
                field-name="street"
            >
                <input
                    v-model.trim="member.street"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.zip')"
                :error="error"
                field-name="zip"
            >
                <input
                    v-model.trim="member.zip"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.city')"
                :error="error"
                field-name="city"
            >
                <input
                    v-model.trim="member.city"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.country')"
                :error="error"
                field-name="country"
            >
                <kgr-countries-select v-model="member.country" />
            </kgr-form-row>
        </fieldset>

        <fieldset class="kgr-grid__cell">
            <legend
                v-t="'Weitere Kontaktmöglichkeiten'"
                class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
            ></legend>

            <kgr-form-row
                :label="$t('member.phone')"
                :error="error"
                field-name="phone"
            >
                <input
                    v-model.trim="member.phone"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.phoneBusiness')"
                :error="error"
                field-name="phoneBusiness"
            >
                <input
                    v-model.trim="member.phoneBusiness"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.phoneMobile')"
                :error="error"
                field-name="phoneMobile"
            >
                <input
                    v-model.trim="member.phoneMobile"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.phoneMobileBusiness')"
                :error="error"
                field-name="phoneMobileBusiness"
            >
                <input
                    v-model.trim="member.phoneMobileBusiness"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.emergencyContact')"
                :error="error"
                field-name="emergencyContact"
            >
                <input
                    v-model.trim="member.emergencyContact"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.email')"
                :error="error"
                field-name="email"
            >
                <input
                    v-model.trim="member.email"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.emailBusiness')"
                :error="error"
                field-name="emailBusiness"
            >
                <input
                    v-model.trim="member.emailBusiness"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>
        </fieldset>
    </div>
</template>

<script>
import CountriesSelect from '../common/form/select/CountriesSelect';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import Member from '../../js/dto/Member';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-countries-select': CountriesSelect,
    },
    props: {
        member: {
            type: Member,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
